/* eslint-disable no-unmodified-loop-condition */
import { get } from "lodash";
import {
  all,
  call,
  cancelled,
  delay,
  fork,
  put,
  select,
  takeLatest
} from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import { GET_MEDICAL_BILL_DETAIL_SUCCESS } from "~/store/booking/bookingType";
import * as notiActions from "~/store/notifications/notificationsActions";
import { apiRequestHealthInsuranceCard } from "~/store/payment/paymentApi";
import * as types from "~/store/payment/paymentType";
import * as totalDataActions from "~/store/totalData/actions";
import { REDIRECT_URL_AFTER_BOOKING } from "~/utils/constants";
import { getDataToReserve, getRouteFollowPartnerId } from "~/utils/func";
import { getBaseUrl } from "~/utils/getBaseUrl";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";

function* checkStatus() {
  try {
    const totalReducer = yield select(state => state.totalData);
    const transactionId = get(
      totalReducer,
      "paymentInformation.bookingInfo.transactionId"
    );

    if (transactionId) {
      const response = yield client.checkTransaction({
        transactionId
      });

      const { status } = response.data;

      switch (status) {
        case 1:
          console.log("tao don hang");
          break;
        case 2:
          console.log("thanh cong");
          openToast("Giao dịch thành công.");
          yield put({
            type: types.STOP_GET_STATUS_TRANSACTION
          });
          history.push("/");
          break;
        case 3:
          console.log("that bai");
          yield put({
            type: types.STOP_GET_STATUS_TRANSACTION
          });

          openToast("Giao dịch thất bại.", "error");
          history.push("/");

          break;
        default:
          yield put({
            type: types.STOP_GET_STATUS_TRANSACTION
          });
          openToast("default", "error");
          break;
      }
    }
  } catch (error) {
    yield put({
      type: types.STOP_GET_STATUS_TRANSACTION
    });
    openToast("Giao dịch error", "error");
  }
}

function* requestStatusTransaction({ status }) {
  if (status === "active") {
    yield put({
      type: types.ACTIVE_STATUS_TRANSACTION
    });
  }

  let loopStatus = yield select(state => state.payment.loopStatus);

  try {
    while (loopStatus) {
      yield call(checkStatus);
      yield delay(5000);
      loopStatus = yield select(state => state.payment.loopStatus);
    }
  } finally {
    if (yield cancelled()) {
      checkStatus.close();
      requestStatusTransaction.close();
    }
  }
}

function* watchRequestStatusTransaction() {
  yield takeLatest(types.GET_STATUS_TRANSACTION, requestStatusTransaction);
}

function* requestHealthInsuranceCard() {
  try {
    const baseUrl = yield select(state => getBaseUrl());
    const { info } = yield select(state => state.user);
    const { paymentID } = yield select(state => state.healthInsuranceCard);
    const response = yield call(
      apiRequestHealthInsuranceCard,
      baseUrl,
      info,
      paymentID
    );
    if (response.error_code) throw new Error("Server error");
    const { data } = response;
    yield put({
      type: types.REQUEST_HEALTH_INSURANCE_CARD_SUCCESS,
      data
    });
    yield put({ type: GET_MEDICAL_BILL_DETAIL_SUCCESS, data: data[0] });
    yield put(
      notiActions.getNotification({
        user_id: info.user_id,
        access_token: info.access_token
      })
    );
  } catch (error) {
    yield put({
      type: types.REQUEST_HEALTH_INSURANCE_CARD_FAIL,
      error
    });
  }
}

function* watchRequestHealthInsuranceCard() {
  yield takeLatest(
    types.REQUEST_HEALTH_INSURANCE_CARD,
    requestHealthInsuranceCard
  );
}

// GET ALL PAYMENTS
function* requestGetAllPaymentMethods({ payload }) {
  try {
    const totalData = yield select(state => state.totalData);
    const bookingInfos = get(totalData, "schedulesSelected", []);
    const booking = bookingInfos.length > 0 ? bookingInfos[0] : null;
    const price = get(booking, "service.price", 0);
    const groupId = totalData.cskhUserId ? 4 : 1;
    const partnerid =
      totalData.paymentInformation?.bookingInfo?.partnerId ||
      (yield select(state => state.totalData.partnerId));
    const treeId = get(totalData, "treeId", "");

    const globalReducer = yield select(state => state.global);
    const platformType = get(globalReducer, "device.type");

    const platform = platformType === "desktop" ? "pc" : "web";

    const response = yield client.getAllPaymentMethod(
      { price: payload || price, groupId: groupId, treeId },
      { partnerid: partnerid || AppId, appid: AppId, platform, treeId }
    );
    const { data } = response;
    yield put({
      type: types.UMC_GET_ALL_PAYMENT_METHODS_SUCCESS,
      data
    });

    if (AppId === "momo") {
      // tìm hình thức là momo
      const momoMethod = data.find(item => item.methodId === "momo");

      // chọn hình thức thanh toán là momo
      yield put({
        type: types.SELECTED_PAYMENT_METHOD,
        method: momoMethod.paymentTypes[0],
        methodId: momoMethod.methodId
      });
    }
  } catch (error) {
    yield put({
      type: types.UMC_GET_ALL_PAYMENT_METHODS_FAIL,
      error
    });
  }
}

function* watchRequestAllPaymentMethod() {
  yield takeLatest(
    types.UMC_GET_ALL_PAYMENT_METHODS,
    requestGetAllPaymentMethods
  );
}

// ALL PAYMENT FEE METHODS
function* requestGetAllFeePaymentMethods() {
  try {
    const fee = yield select(state => state.fee);
    const priceFeePayment = get(fee, "selectedFee.amount", 0);

    const partnerid = yield select(state => state.totalData.partnerId);
    const response = yield client.getAllPaymentMethod(
      { price: priceFeePayment, groupId: 2 },
      { partnerid: partnerid, appid: AppId }
    );
    const { data } = response;
    yield put({
      type: types.UMC_GET_ALL_PAYMENT_METHODS_SUCCESS,
      data
    });
  } catch (error) {
    yield put({
      type: types.UMC_GET_ALL_PAYMENT_METHODS_FAIL,
      error
    });
  }
}

function* watchRequestAllFeePaymentMethod() {
  yield takeLatest(
    types.GET_ALL_PAYMENT_METHOD_FEE,
    requestGetAllFeePaymentMethods
  );
}

// CHECK REQUIRE PAYMENT
function* requestCheckRequirePayment() {
  try {
    const totalDataReducer = yield select(state => state.totalData);
    const globalReducer = yield select(state => state.global);
    const paymentMethodReducer = yield select(state => state.payment);
    const patientReducer = yield select(state => state.patient);
    const reExamReducer = yield select(state => state.followUpExam);

    const partnerId = get(totalDataReducer, "partnerId");

    const postData = getDataToReserve(
      totalDataReducer,
      globalReducer,
      paymentMethodReducer,
      patientReducer,
      reExamReducer
    );

    const price = get(totalDataReducer, "service.price", "0");

    postData.subTotal = price;
    postData.redirectUrl = REDIRECT_URL_AFTER_BOOKING;

    const response = yield client.isRequirePayment(postData, {
      partnerid: partnerId,
      appid: AppId
    });
    const isRequirePayment = get(response, "data.isRequirePayment", true);
    if (isRequirePayment) {
      const route = getRouteFollowPartnerId("/hinh-thuc-thanh-toan", partnerId);
      history.push(route);
    } else {
      yield put(totalDataActions.reserveBooking());
    }
  } catch (error) {
    console.log(error);
  }
}

function* watcherRequestCheckRequirePayment() {
  yield takeLatest(types.CHECK_REQUIRE_PAYMENT, requestCheckRequirePayment);
}

export default function* root() {
  yield all([
    fork(watchRequestStatusTransaction),
    fork(watchRequestHealthInsuranceCard),
    fork(watchRequestAllPaymentMethod),
    fork(watchRequestAllFeePaymentMethod),
    fork(watcherRequestCheckRequirePayment)
  ]);
}
